module.exports = __webpack_public_path__ + "static/media/fruits_8.0818282a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_8.csv
// module id = 724
// module chunks = 0